//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBizType } from "@/js/utils";

export default {
    name: "couponDiscountList",
    props: {
        repayInitData: {
            type: Object,
        },
        redPacketAmount: String,
        isChooseGold: String,
        couponUsed: String,
        repayPage: Number,
        showRepayfmCoupon: Boolean,
        showRepaydlCoupon: Boolean,
    },
    computed: {
        isGoldOpened() {
            return this.isChooseGold === "y";
        },
        discountInfo() {
            const {
                reduceCouponAmount,
                reduceActivityAmount,
                redEnvelopes,
                growthCouponVos,
                gyCouponsAmount,
                repayShowPrincipal,
                repayShowInterestFee,
                isXW,
                downAmount,
                upAmount,
                interestFreeAmount,
                isFeeTouMing,
                repayfmCouponAmount,
                repaydlCouponAmount,
                repayVipBenefitAmount
            } = this.repayInitData;

            const hasGrowthCouponVos =
                growthCouponVos && growthCouponVos.length > 0;

            return {
                coupon: {
                    text: "免息券减免",
                    amount: reduceCouponAmount,
                },
                holiday: {
                    text: "活动减免",
                    amount: reduceActivityAmount,
                },
                gyFreeCoupon: {
                    text: "公益免息券减免",
                    amount: gyCouponsAmount,
                },
                growthCouponVo: {
                    amount: hasGrowthCouponVos
                        ? growthCouponVos[0].couponAmount
                        : "",
                },
                principal: {
                    text: "还款本金",
                    amount: repayShowPrincipal,
                    isShow: repayShowPrincipal > 0 && this.isLoan,
                },
                interestFee: {
                    text: "待还息费（包含罚息）",
                    amount: repayShowInterestFee,
                    isShow: repayShowInterestFee > 0 && this.isLoan,
                },
                interestSaved: {
                    text: "节省息费",
                    amount: interestFreeAmount,
                    isShow: isXW && (!isFeeTouMing) && upAmount !== downAmount && interestFreeAmount > 0
                },
                repayfmCoupon: {
                    text: "费免券减免",
                    amount: repayfmCouponAmount,
                    isShow: repayfmCouponAmount > 0 && this.showRepayfmCoupon
                },
                repaydlCoupon: {
                    text: "优惠减免",
                    amount: repaydlCouponAmount,
                    isShow: repaydlCouponAmount > 0 && this.showRepaydlCoupon
                },
                hasCouponDiscount: reduceCouponAmount > 0,
                hasHolidayDiscount: reduceActivityAmount > 0,
                isRedEnvelopesShow: redEnvelopes && redEnvelopes.length > 0,
                hasGrowthCouponVos: hasGrowthCouponVos,
                hasGyFreeCoupon: gyCouponsAmount > 0,
                isFeeTouMing: isFeeTouMing,
                hasVipBenefit: repayVipBenefitAmount > 0, // 会员权益按期优惠(后返)
            };
        },

        parter1() {
            return (
                this.discountInfo.hasCouponDiscount ||
                this.discountInfo.hasHolidayDiscount ||
                this.discountInfo.hasGyFreeCoupon ||
                this.discountInfo.principal.isShow ||
                this.discountInfo.interestFee.isShow ||
                this.discountInfo.interestSaved.isShow ||
                this.discountInfo.repayfmCoupon.isShow ||
                this.discountInfo.repaydlCoupon.isShow
            );
        },

        parter2() {
            return (
                this.discountInfo.isRedEnvelopesShow ||
                this.isGoldOpened ||
                this.discountInfo.hasGrowthCouponVos ||
                this.discountInfo.hasVipBenefit
            );
        },

        hasChooseGold() {
            return [3, 4].includes(this.repayPage) && this.isChooseGold === "y";
        },
        isLoan() {
            return getBizType() == "Loan";
        },
    },
    mounted() {
        if (
            this.discountInfo.hasGrowthCouponVos &&
            !this.redPacketAmount &&
            this.couponUsed != "noUsed"
        ) {
            const { bizType, batchNo } = this.repayInitData.growthCouponVos[0];
            this.sendRecord("1070", `${bizType},${batchNo}`);
        }
    },
    methods: {
        sendPoint() {
            if (
                this.discountInfo.hasGrowthCouponVos &&
                !this.redPacketAmount &&
                this.couponUsed != "noUsed"
            ) {
                const { bizType, batchNo } =
                    this.repayInitData.growthCouponVos[0];
                this.sendRecord("1071", `${bizType},${batchNo}`);
            }
        },
    },
};
